import { render, staticRenderFns } from "./transactions-report-details-column.vue?vue&type=template&id=3a0976c0&"
import script from "./transactions-report-details-column.vue?vue&type=script&lang=js&"
export * from "./transactions-report-details-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports